import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Heading, Paragraph } from 'grommet';
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image';
import RichText from './RichText';

const ContentContainer = styled.div`
  padding: 40px var(--outerGutter);
  display: flex;
  justify-content: left;
  align-items: center;
  grid-area: content;
`;

const ImageContainer = styled.div`
  width: 100%;
  grid-area: image;
`;

const HeroContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-areas: 'image' 'content';

  @media ${({ theme }) => theme.custom.layouts.above_medium} {
    grid-template-areas: 'content image';
    grid-template-columns: repeat(2, 1fr);
  }
  @media ${({ theme }) => theme.custom.layouts.above_large} {
    margin: 0 auto;
    height: 380px;
  }
  @media ${({ theme }) => theme.custom.layouts.above_xlarge} {
    max-width: var(--breakpointWidth);
  }
`;

const StyledHero = styled(Box)`
  overflow: hidden;
  width: 100%;
`;

const StyledRichText = styled(RichText)`
  h3 {
    font-family: 'PwC ITC Charter', Georgia, serif;
    font-size: 24px;
    line-height: 1.5;
    font-weight: normal;
    max-width: 480px;
    padding-top: 4px;

  }
`;

const Hero = ({ title, subtitle, image }) => {
  return (
    <StyledHero background={'dark-4'}>
      <HeroContainer>
        <ContentContainer>
          <div>
            <Box pad={{ bottom: '.2rem' }}>
              <Heading margin={{ bottom: '20px' }} color={'light-1'} level={1}>
                {title}
              </Heading>
            </Box>
            <StyledRichText textColor={'light-1'} richText={subtitle} />
          </div>
        </ContentContainer>
        <ImageContainer>
          <GatsbyImage
            style={{ height: '100%', width: '100%' }}
            imgStyle={{ height: '100%', width: '100%' }}
            objectFit="cover"
            objectPosition="center center"
            image={image.gatsbyImageData}
            alt={image.description}
          />
        </ImageContainer>
      </HeroContainer>
    </StyledHero>
  );
};

Hero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.object.isRequired,
  image: PropTypes.object.isRequired,
};

export default Hero;
